var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.balance)?_c('button',{staticClass:"button is-small",class:_vm.hasPaid},[(_vm.balance > 0)?_c('span',[_vm._v(_vm._s(_vm._f("formatNumber")(_vm.balance))+_vm._s(_vm.currency))]):_c('span',[_vm._v(_vm._s(_vm.balance))])]):_c('button',{staticClass:"button is-small"},[_vm._v("PENDING")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc670e2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cars/Columns/BalanceColumn.vue
// module id = null
// module chunks = 